/** Starter document shown on first visit (and after a reset). */
export const SAMPLE_TEX = String.raw`\documentclass[11pt]{article}
\usepackage[T1]{fontenc}
\usepackage[utf8]{inputenc}
\usepackage[margin=2.5cm]{geometry}
\usepackage{amsmath,amssymb}

\title{Hello, \LaTeX}
\author{Your Name}
\date{\today}

\begin{document}
\maketitle

\section{Getting started}
Everything on this page is typeset by pdfTeX running in your browser.
Edit the source on the left and press \emph{Compile} to refresh the PDF.

Inline math sits in the running text, like $e^{i\pi} + 1 = 0$, and
displayed equations can be numbered:
\begin{equation}
  \int_{-\infty}^{\infty} e^{-x^2} \, dx = \sqrt{\pi}.
  \label{eq:gauss}
\end{equation}

\section{A little more}
Reference equations by label, as in \eqref{eq:gauss}, and align
multi-step work:
\begin{align*}
  (a + b)^2 &= a^2 + 2ab + b^2 \\
            &\geq 4ab \quad \text{for } a, b \geq 0.
\end{align*}

\begin{itemize}
  \item Lists, sections, and cross-references all work as usual.
  \item When something breaks, the compile log points at the line.
\end{itemize}

Citations work through the built-in bibliography
environment~\cite{knuth1986}, and resolve in a single compile here.

\begin{thebibliography}{9}
\bibitem{knuth1986}
Donald~E. Knuth.
\emph{The \TeX book}.
Addison-Wesley, 1986.
\end{thebibliography}

\end{document}
`;
